import styled from 'styled-components';
const percentageSize = 1.3;

export const CercaContainer = styled.div`
  display: ${(props) => (props.isOpen ? 'block' : 'none')};
  background-color: rgba(51, 51, 51, 0.85);
  position: fixed;
  z-index: 8;
  width: 100%;
  align-items: center;
  justify-content: center;
  color: white;
  top: 40px;
  /* height: ${`calc(100% - 40px)`}; */
  height: 75%;

  @media screen and (max-width: 768px) {
    height: calc(100% - 80px);
    top: 80px;
  }
`;

export const CercaWrapper = styled.div`
  display: grid;
  grid-template-rows: 45px 0.5px ${` calc(100% - 40px - 45px - 70px - 0.5px)`} 70px;

  @media screen and (max-width: 768px) {
    grid-template-rows: 45px 0.5px ${` calc(100% - 80px - 45px - 70px - 0.5px)`} 70px;
  }
`;

export const CercaHeader = styled.div`
  border-bottom: 1.5px solid transparent;
  display: inline-flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  z-index: 4;
  margin-left: 18%;
  @media screen and (max-height: 400px) {
    margin: 0 5% 0 5%;
  }
  @media screen and (max-width: 768px) {
    overflow-y: hidden;
    width: 95%;
    height: 110%;
    margin-left: 10px;
    ::-webkit-scrollbar {
      width: 0px;
      height: 0px;
    }
  }
`;

export const CercaTitleContainer = styled.div`
  height: 100%;
`;

export const CercaTitleWrapper = styled.div`
  width: fit-content;
  display: inline-flex;
  flex-direction: row;
  justify-content: center;
  align-items: flex-start;
  height: 100%;
  box-sizing: content-box;
  white-space: nowrap;

  @media screen and (max-width: 768px) {
    margin-left: 0px;
  }
`;

export const CercaTitle = styled.h3`
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: ${({ fontSizeEnabled }) => (fontSizeEnabled ? 18 * percentageSize : 18)}px;
  width: fit-content;
  box-sizing: inherit;
  margin: 0;
  padding-right: 15px;
  height: 100%;
  padding-left: 15px;
  font-weight: ${(props) => (props.selected ? '500' : '200')};
  line-height: 1.2;
  color: ${(props) => (props.selected ? '#febf00' : 'white')};
  cursor: pointer;
  border-bottom: ${(props) => (props.selected ? '4px solid #febf00;' : 'none')};

  @media screen and (max-width: 768px) {
    height: 92%;
  }
`;

export const CercaCloseBtn = styled.button`
  background: transparent;
  color: white;
  opacity: 90%;
  border-radius: 50%;
  border: 0;
  padding-right: 1%;
  box-sizing: border-box;
  text-align: right;
  position: absolute;
  right: 0;
  @media screen and (max-width: 464px) {
    display: none;
  }
`;

export const CercaCloseBtnIcon = styled.img`
  vertical-align: top;
  height: ${({ fontSizeEnabled }) => (fontSizeEnabled ? 12 * percentageSize : 12)}px;
  width: ${({ fontSizeEnabled }) => (fontSizeEnabled ? 12 * percentageSize : 12)}px;
`;

export const SeparatorRow = styled.div`
  content: '';
  background-color: #b7b7b7;
  width: 98%;
  height: 2px;
  margin-left: auto;
  margin-right: auto;
  opacity: 80%;
`;

export const CercaFooter = styled.footer`
  display: block;
  position: absolute;
  bottom: 0;
  width: 100%;
  height: 70px;
  padding-left: 1%;
  padding-right: 1%;
`;

export const CercaBody = styled.article`
  height: 100%;
  display: block;
  padding-left: 1%;
  padding-right: 1%;

  @media screen and (max-width: 464px) {
  }
`;

export const CercaBodyWrapper = styled.div`
  display: grid;
  height: 100%;
  grid-template-rows: 100px 60px ${`calc(100% - 100px - 60px)`};

  @media screen and (max-height: 400px) {
    grid-template-rows: 80px 60px ${`calc(100% - 100px - 60px)`};
  }
`;

export const FiltresWrapper = styled.div`
  margin: 0;
  display: none;
  flex-direction: row;
  align-items: center;
  justify-content: flex-start;
  margin-left: 18%;
  margin-right: 18%;
  @media screen and (max-height: 400px) {
    margin: 0 5% 0 5%;
  }
  @media screen and (max-width: 768px) {
    margin-left: 20px;
    margin-right: 20px;
  }

  @media screen and (max-width: 464px) {
    margin-left: 5%;
    margin-right: 5%;
  }
`;

export const FiltresLabel = styled.label`
  margin: 0;
  margin-right: 10px;
  font-size: ${({ fontSizeEnabled }) => (fontSizeEnabled ? 14 * percentageSize : 14)}px;
`;

export const SelectWrapper = styled.div`
  height: fit-content;
  width: fit-content;

  @media screen and (max-width: 464px) {
    width: 100%;
  }
`;

export const ResultatsCapesWrapper = styled.div``;

export const ElementsTrobatsWrapper = styled.div``;

export const CercaFooterWrapper = styled.div`
  width: 100%;
  display: flex;
  padding-left: 18%;
  justify-content: flex-start;

  @media screen and (max-width: 768px) {
    padding-left: 0px;
    justify-content: center;
  }
`;

export const BtnCercaAsistida = styled.button`
  background-color: transparent;
  border: 2px solid white;
  border-radius: 5px;
  margin-right: 20px;
  padding-left: 10px;
  padding-right: 10px;
  display: none;

  @media screen and (max-width: 464px) {
    border-radius: 5px;
    margin-right: 15px;
    padding-left: 8px;
    padding-right: 8px;
  }
`;

export const BtnCercaAsistidaWrapper = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
`;

export const LinkCercaAsistida = styled.a`
  color: white;
  font-size: ${({ fontSizeEnabled }) => (fontSizeEnabled ? 16 * percentageSize : 16)}px;
  display: none;

  @media screen and (max-width: 464px) {
    font-size: ${({ fontSizeEnabled }) => (fontSizeEnabled ? 12 * percentageSize : 12)}px;
  }
`;

export const TitolCercaBodyWrapper = styled.div`
  padding-left: 18%;
  padding-right: 18%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: flex-start;
  @media screen and (max-height: 400px) {
    padding: 0 5% 0 5%;
    justify-content: flex-start;
    margin-top: 10px;
  }
  @media screen and (max-width: 768px) {
    padding: 4px;
    padding-left: 20px;
    padding-right: 20px;

    display: block;
  }

  @media screen and (max-width: 464px) {
    padding: 5%;
    display: block;
  }
`;

export const TitolCercaBody = styled.h2`
  font-size: ${({ fontSizeEnabled }) => (fontSizeEnabled ? 24 * percentageSize : 24)}px;
  margin: 0;
  font-weight: 400;

  @media screen and (max-width: 768px) {
    font-size: ${({ fontSizeEnabled }) => (fontSizeEnabled ? 20 * percentageSize : 20)}px;
  }

  @media screen and (max-width: 464px) {
    font-size: ${({ fontSizeEnabled }) => (fontSizeEnabled ? 16 * percentageSize : 16)}px;
    font-weight: 500;
  }
`;

export const DescripcioCercaBody = styled.p`
  font-size: ${({ fontSizeEnabled }) => (fontSizeEnabled ? 14 * percentageSize : 14)}px;
  margin: 0;
  margin-top: 10px;
  text-align: justify;

  @media screen and (max-width: 464px) {
    font-size: ${({ fontSizeEnabled }) => (fontSizeEnabled ? 12 * percentageSize : 12)}px;
  }

  @media screen and (max-width: 464px) {
    font-size: ${({ fontSizeEnabled }) => (fontSizeEnabled ? 12 * percentageSize : 12)}px;
    font-weight: 200;
  }
`;

export const TornarAlMapaButton = styled.button`
  margin-top: 15px;
  margin-bottom: 15px;
  height: 32px;
  font-size: ${({ fontSizeEnabled }) => (fontSizeEnabled ? 14 * percentageSize : 14)}px;
  background: #c00000;
  color: white;
  padding: 3px 25px;
  border: none;
  text-align: center;
  vertical-align: middle;
  border-radius: 0.5em;
  font-weight: bold;

  @media screen and (max-width: 768px) {
    font-size: ${({ fontSizeEnabled }) => (fontSizeEnabled ? 12 * percentageSize : 12)}px;
    width: 100%;
    margin-left: 10px;
    margin-right: 10px;
    padding: 5px 25px;
  }
`;

export const SpinnerContainer = styled.div`
  margin: auto;
`;
